var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChangePass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1572 0C16.0424 0 20 4.5 20 10C20 15.5 16.0424 20 11.1572 20C8.05654 20 5.34452 18.18 3.76325 15.43L5.15901 14.18C6.40459 16.47 8.62191 18 11.1661 18C13.0404 18 14.838 17.1571 16.1633 15.6569C17.4886 14.1566 18.2332 12.1217 18.2332 10C18.2332 7.87827 17.4886 5.84344 16.1633 4.34315C14.838 2.84285 13.0404 2 11.1661 2C7.56184 2 4.59364 5.06 4.16078 9H6.59894L3.29505 12.73L0 9H2.37633C2.81802 3.95 6.58127 0 11.1572 0ZM13.7721 8.24C14.2138 8.25 14.576 8.65 14.576 9.16V13.77C14.576 14.27 14.2138 14.69 13.7633 14.69H8.87809C8.42756 14.69 8.06537 14.27 8.06537 13.77V9.16C8.06537 8.65 8.42756 8.25 8.86926 8.24V7.23C8.86926 5.7 9.9735 4.46 11.3163 4.46C12.6678 4.46 13.7721 5.7 13.7721 7.23V8.24ZM11.3163 5.86C10.6537 5.86 10.106 6.47 10.106 7.23V8.24H12.5353V7.23C12.5353 6.47 11.9876 5.86 11.3163 5.86Z",
    fill: "#F66524"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChangePass);
export default __webpack_public_path__ + "static/media/IconChangePass.b5d2f6e4732ed744bf8ad54e1e4b88c3.svg";
export { ForwardRef as ReactComponent };